import { Subject } from "rxjs";

export function callNextAsync(subscriber: Subject<any>, v: any): Promise<void> {
    var act = async () => {
        subscriber.next(v);
    };
    return act();
}

export function callNext(subscriber: Subject<any>, v: any) {
    subscriber.next(v);
}
